import { useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import EligibleProgramsResult from './EligibleProgramsResult';
import { LanguageSwitcher } from '../../../shared/components/localization/LanguageSwitcher';
import { NS } from '../../../models/I18n';
import { useSubmissionResultQuery } from '../../SubmissionAPI';
import { getEligibilityCheckToken } from '../../../shared/utils/getEligibilityCheckToken';

export function EligibleProgramsView() {
  const { t } = useTranslation(NS.Shared);
  const match = useRouteMatch<{ submissionId: string }>('/eligibility/:submissionId/result');
  const { data, isLoading } = useSubmissionResultQuery(match?.params.submissionId || '');
  const eligibilityCheckToken = getEligibilityCheckToken();
  if (isLoading || !data) {
    return null;
  }
  const { submission, organization, user } = data;
  if (organization && organization.eligibility_check_token !== eligibilityCheckToken) {
    if (organization.config?.show_results_for_lead) {
      return (
        <div className="min-h-screen">
          <EligibleProgramsResult submission={submission} organization={organization} />
        </div>
      );
    }
    return (
      <div>
        <div className="flex w-full justify-between px-3 pt-3">
          <img className="max-w-[130px]" src={organization.logo} alt={`${organization.name}'s logo`} />
          <LanguageSwitcher showSpinner={false} />
        </div>
        <h3 className="mt-3 text-center text-base font-semibold text-gray-600 lg:text-lg">
          {organization.config?.thank_you_message || t('result.default-thank-you-message')}
        </h3>
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <EligibleProgramsResult submission={submission} user={user} />
    </div>
  );
}
